import * as React from 'react'
import { createPortal } from 'react-dom'
import clx from 'classnames'

type SidebarTooltipProps = {
  text: string
  children: React.ReactNode
  enabled?: boolean
  className?: string
}


export const SidebarTooltip: React.FC<SidebarTooltipProps> = ({
  text,
  children,
  enabled = true,
  className = '',
}) => {
  const [visible, setVisible] = React.useState(false)
  const [coords, setCoords] = React.useState({ top: 0, left: 0 })
  const wrapperRef = React.useRef<HTMLDivElement>(null)

  const GAP = 12 

  const show = () => {
    const el = wrapperRef.current
    if (!el) return
    const rect = el.getBoundingClientRect()
    setCoords({
      top: rect.top + rect.height / 2,
      left: rect.right + GAP,
    })
    setVisible(true)
  }

  const hide = () => setVisible(false)

  if (!enabled || !text) return <>{children}</>

  return (
    <div
      ref={wrapperRef}
      className={className}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}
      {visible &&
        createPortal(
          <div
            style={{ top: coords.top, left: coords.left }}
            className={clx(
              'tw-pointer-events-none tw-fixed tw-z-[1000] tw--translate-y-1/2',
              'tw-select-none tw-whitespace-nowrap tw-rounded tw-bg-neutral-900',
              'tw-p-1 tw-opacity-90 tw-shadow-lg',
            )}
          >
            <p className="tw-text-sm tw-text-secondary">{text}</p>
            <div className="tw-absolute tw-left-[-4px] tw-top-1/2 tw-h-2 tw-w-2 tw--translate-y-1/2 tw-rotate-45 tw-bg-neutral-900" />
          </div>,
          document.body,
        )}
    </div>
  )
}

export default SidebarTooltip
